// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.TotalVideoCountChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.AdTotalAdViewsChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.AdTotalAdViewsNoForceChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.AdGeneralEngagementChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;